import { useWSModal } from "@wingspanhq/fe-component-library";
import { ConfirmRateCardEditModal } from "./index";

export const useConfirmRateCardEditModal = () =>
  useWSModal(ConfirmRateCardEditModal, {
    title: "Confirm rate card edits",
    size: "M"
  });
